module.exports = __webpack_public_path__ + "img/Logo only.71086f34.svg";